(function() {
    'use strict';

    angular.module('allegro').controller('AccountSettingsController', AccountSettingsController);

    AccountSettingsController.$inject = [
        '$scope',
        '$state',
        'notificationSrvc',
        'checkModelPermissionsSrvc',
        'allegroAccountDataSrvc',
        'allegroConfigPermissionsConst',
        'allegroSellerPermissionsConst',
        'allegroSenderPermissionsConst',
        'allegroCodReceiverPermissionsConst',
        'allegroResponsibleProducerPermissionsConst',
        'allegroSafetyInformationPermissionsConst'
    ];

    function AccountSettingsController(
        $scope,
        $state,
        notificationSrvc,
        checkModelPermissionsSrvc,
        allegroAccountDataSrvc,
        allegroConfigPermissionsConst,
        allegroSellerPermissionsConst,
        allegroSenderPermissionsConst,
        allegroCodReceiverPermissionsConst,
        allegroResponsibleProducerPermissionsConst,
        allegroSafetyInformationPermissionsConst
    ) {
        var self = this;

        self.loading = {
            oauth: false,
            seller: false,
            sender: false,
            receiver: false,
            responsibleProducer: false,
            safetyInformation: false
        };

        self.oauthData = null;
        self.sellerData = null;
        self.senderData = null;
        self.receiverData = null;
        self.responsibleProducerData = null;
        self.safetyInformationData = null;

        self.activate = activate;
        self.getAccountOAuthData = getAccountOAuthData;
        self.getAccountSellerData = getAccountSellerData;
        self.getAccountSenderData = getAccountSenderData;
        self.getAccountReceiverData = getAccountReceiverData;
        self.getAccountResponsibleProducerData = getAccountResponsibleProducerData;
        self.getAccountProductSafetyInfoData = getAccountProductSafetyInfoData;
        self.isEmpty = isEmpty;

        // Model Permissions Check
        self.hasConfigViewPerm = hasConfigViewPerm;
        self.hasConfigCreatePerm = hasConfigCreatePerm;
        self.hasConfigUpdatePerm = hasConfigUpdatePerm;

        self.hasSellerViewPerm = hasSellerViewPerm;
        self.hasSellerCreatePerm = hasSellerCreatePerm;
        self.hasSellerUpdatePerm = hasSellerUpdatePerm;

        self.hasSenderViewPerm = hasSenderViewPerm;
        self.hasSenderCreatePerm = hasSenderCreatePerm;
        self.hasSenderUpdatePerm = hasSenderUpdatePerm;

        self.hasCodReceiverViewPerm = hasCodReceiverViewPerm;
        self.hasCodReceiverCreatePerm = hasCodReceiverCreatePerm;
        self.hasCodReceiverUpdatePerm = hasCodReceiverUpdatePerm;

        self.hasResponsibleProducerViewPerm = hasResponsibleProducerViewPerm;
        self.hasResponsibleProducerCreatePerm = hasResponsibleProducerCreatePerm;
        self.hasResponsibleProducerUpdatePerm = hasResponsibleProducerUpdatePerm;

        self.hasSafetyInformationViewPerm = hasSafetyInformationViewPerm;
        self.hasSafetyInformationCreatePerm = hasSafetyInformationCreatePerm;
        self.hasSafetyInformationUpdatePerm = hasSafetyInformationUpdatePerm;

        $scope.$watch('$parent.account', function(account) {
            if (account) {
                self.account = account;
                self.activate();
            }
        });

        function activate() {
            self.getAccountOAuthData($state.params.pk);
            self.getAccountSellerData($state.params.pk);
            self.getAccountSenderData($state.params.pk);
            self.getAccountReceiverData($state.params.pk);
            self.getAccountResponsibleProducerData($state.params.pk);
            self.getAccountProductSafetyInfoData($state.params.pk)
        }

        function getAccountOAuthData(accountPk) {
            self.loading.oauth = true;

            return allegroAccountDataSrvc.getOAuthData({pk: accountPk})
                .$promise
                .then(function (response) {
                    if (response.pk) {
                        self.oauthData = response;
                    }
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading.oauth = false;
                    return response;
                });
        }

        function getAccountSellerData(accountPk){
            self.loading.seller = true;

            return allegroAccountDataSrvc.getSellerData({pk: accountPk})
                .$promise
                .then(function (response) {
                    if (response.pk){
                        self.sellerData = response
                    }
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading.seller = false;
                    return response;
                });
        }

        function getAccountSenderData(accountPk) {
            self.loading.sender = true;

            return allegroAccountDataSrvc.getSenderData({pk: accountPk})
                .$promise
                .then(function (response) {
                    if (response.pk) {
                       self.senderData = response;
                    }
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading.sender = false;
                    return response;
                });
        }

        function getAccountReceiverData(accountPk) {
            self.loading.receiver = true;

            return allegroAccountDataSrvc.getCodReceiverData({pk: accountPk})
                .$promise
                .then(function (response) {
                    if (response.pk) {
                       self.receiverData = response;
                    }
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading.receiver = false;
                    return response;
                });
        }

        function getAccountResponsibleProducerData(accountPk){
            self.loading.responsibleProducer = true;

            return allegroAccountDataSrvc.getResponsibleProducerData({pk: accountPk})
                .$promise
                .then(function (response) {
                    if (response.pk) {
                       self.responsibleProducerData = response;
                    }
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading.responsibleProducer = false;
                    return response;
                });
        }

        function getAccountProductSafetyInfoData(accountPk){
            self.loading.safetyInformation = true;

            return allegroAccountDataSrvc.getSafetyInformationData({pk: accountPk})
                .$promise
                .then(function (response) {
                    if (response.pk) {
                       self.safetyInformationData = response;
                    }
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading.safetyInformation = false;
                    return response;
                });
        }

        function isEmpty(obj) {
            return !obj || Object.keys(obj).length === 0;
        }

        function hasConfigViewPerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.view);
        }

        function hasConfigCreatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.add);
        }

        function hasConfigUpdatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroConfigPermissionsConst.update);
        }

        function hasSellerViewPerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSellerPermissionsConst.view);
        }

        function hasSellerCreatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSellerPermissionsConst.add);
        }

        function hasSellerUpdatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSellerPermissionsConst.update);
        }

        function hasSenderViewPerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSenderPermissionsConst.view);
        }

        function hasSenderCreatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSenderPermissionsConst.add);
        }

        function hasSenderUpdatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSenderPermissionsConst.update);
        }

        function hasCodReceiverViewPerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroCodReceiverPermissionsConst.view);
        }

        function hasCodReceiverCreatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroCodReceiverPermissionsConst.add);
        }

        function hasCodReceiverUpdatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroCodReceiverPermissionsConst.update);
        }


        function hasResponsibleProducerViewPerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroResponsibleProducerPermissionsConst.view);
        }

        function hasResponsibleProducerCreatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroResponsibleProducerPermissionsConst.add);
        }

        function hasResponsibleProducerUpdatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroResponsibleProducerPermissionsConst.update);
        }

        function hasSafetyInformationViewPerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSafetyInformationPermissionsConst.view);
        }

        function hasSafetyInformationCreatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSafetyInformationPermissionsConst.add);
        }

        function hasSafetyInformationUpdatePerm() {
            return !checkModelPermissionsSrvc.isDenied(allegroSafetyInformationPermissionsConst.update);
        }
    }
})();
